import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencyBanner() {
  const [spotsTaken, setSpotsTaken] = useState(() => {
    if (typeof window === 'undefined') return 72;
    const saved = sessionStorage.getItem('chikung-spots');
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 45) * 1;
      return Math.min(value + increment, 94);
    }
    return 72;
  });
  const [timeLeft, setTimeLeft] = useState({
    h: 1,
    m: 0,
    s: 0
  });
  useEffect(() => {
    if (typeof window === 'undefined') return;
    sessionStorage.setItem('chikung-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 94) return prev;
        const increment = Math.random() < 0.3 ? 1 : 0;
        return Math.min(prev + increment, 94);
      });
    }, 30000 + Math.random() * 30000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-brand-purpleDark text-brand-surface border-b border-brand-gold/40" data-id="element-254" data-mp="2cekue47zekd3">
      <div className="max-w-7xl mx-auto px-3 py-2 md:px-6 md:py-2.5" data-id="element-255" data-mp="1510ufsqo7jpy">
        <div className="md:hidden overflow-hidden relative" data-id="element-256" data-mp="10y4gifc2sbsc">
          <motion.div className="flex items-center gap-6 whitespace-nowrap text-[11px] font-medium w-max" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 20,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-257" data-mp="1110hkcj7zgl0">
            {[0, 1].map(dup => <div key={dup} className="flex items-center gap-6 shrink-0" data-id="element-258" data-mp="shdnjbe6vth4">
                <div className="flex items-center gap-1.5 shrink-0 text-brand-goldLight" data-id="element-259" data-mp="xfouned3npvn">
                  <Clock className="w-3.5 h-3.5 shrink-0" data-id="element-260" data-mp="joaedfaku2sa" />
                  <span data-id="element-261" data-mp="og1uevw3wq46">El precio de lanzamiento cierra en</span>
                  <span className="font-mono font-bold tabular-nums border border-brand-gold/40 rounded-sm px-1.5 py-0.5 ml-0.5 text-white" data-id="element-262" data-mp="ohlaomhrj15y">
                    {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
                  </span>
                </div>
                <span className="w-1 h-1 rotate-45 bg-brand-goldLight/60 shrink-0" data-id="element-263" data-mp="pxv30pybciz" />
                <div className="flex items-center gap-1.5 shrink-0" data-id="element-264" data-mp="4rt2mmyh6m57">
                  <span className="w-1.5 h-1.5 rounded-full bg-brand-burgundy animate-pulse" data-id="element-265" data-mp="4u5gop144ccz" />
                  <span data-id="element-266" data-mp="3ib92lw92rnl5">
                    <strong className="tabular-nums text-brand-goldLight" data-id="element-267" data-mp="3da1x63uen0hn">
                      {spotsTaken}%
                    </strong>{' '}
                    de los cupos tomados
                  </span>
                </div>
                <span className="w-1 h-1 rotate-45 bg-brand-goldLight/60 shrink-0" data-id="element-268" data-mp="3m9ox0l7hjy8l" />
                <a href="#pricing" className="inline-flex items-center gap-1 border border-brand-goldLight/70 text-brand-goldLight font-semibold uppercase tracking-wider px-2.5 py-0.5 rounded-sm text-[10px] shrink-0" data-id="element-269" data-mp="5236txvyfho0">
                  Ver el pack
                </a>
              </div>)}
          </motion.div>
        </div>

        <div className="hidden md:flex items-center justify-center gap-6 text-xs font-medium" data-id="element-270" data-mp="9ummd0e7cmvg">
          <div className="flex items-center gap-2 whitespace-nowrap text-brand-goldLight uppercase tracking-wider" data-id="element-271" data-mp="nu5rdkbpvi3j">
            <Clock className="w-4 h-4 shrink-0" data-id="element-272" data-mp="ivktvsnuncis" />
            <span data-id="element-273" data-mp="12wdx726a6b8w">El precio de lanzamiento cierra en</span>
            <span className="font-mono font-bold tabular-nums border border-brand-gold/40 rounded-sm px-2 py-0.5 text-white normal-case" data-id="element-274" data-mp="12vvwntcl5av6">
              {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
            </span>
          </div>
          <div className="w-px h-4 bg-brand-goldLight/30 shrink-0" data-id="element-275" data-mp="1gn99kofznah8" />
          <div className="flex items-center gap-2 whitespace-nowrap" data-id="element-276" data-mp="1gpn8x9hpb8ul">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-burgundy animate-pulse" data-id="element-277" data-mp="jyunrxfwuqly" />
            <span className="text-brand-surface/85" data-id="element-278" data-mp="nzmxsswlwzja">
              <strong className="tabular-nums text-brand-goldLight" data-id="element-279" data-mp="sxy9l96gpk45">
                {spotsTaken}%
              </strong>{' '}
              de los cupos tomados
            </span>
          </div>
          <a href="#pricing" className="inline-flex items-center gap-1 border border-brand-goldLight/70 text-brand-goldLight font-semibold uppercase tracking-wider px-3 py-1 rounded-sm text-[10px] hover:bg-brand-goldLight hover:text-brand-purpleDark transition-colors shrink-0" data-id="element-280" data-mp="24d3orcns5b4n">
            Ver el pack
          </a>
        </div>
      </div>
    </div>;
}